export class AppConfig {
    readonly apiUrl: string
    readonly apiKey: string

  constructor(apiUrl: string, apiKey: string) {
      this.apiUrl = apiUrl
      this.apiKey = apiKey
  }
}
